import { Button, Stack, Typography } from '@mui/material'
import { FC } from 'react'

import { useRouter, useTranslation } from '@/core'

type Props = {
  gachaId: string
  artistId: string
  endAt?: string | null
  deliveryDateText?: string | null
  onClickDetail: () => void
}
/**
 * @description
 * 「終了日」「詳細へ」「排出一覧」などのガチャ詳細データ表示
 */
export const GachaInformation: FC<Props> = ({
  gachaId,
  artistId,
  endAt,
  deliveryDateText,
  onClickDetail,
}) => {
  const { generatePath, routerPages } = useRouter()
  const { t } = useTranslation('gachaDetail')

  return (
    <Stack
      direction="row"
      sx={{ py: 2, px: 5 }}
      alignItems="center"
      justifyContent="space-between"
    >
      <Stack spacing={1}>
        {endAt && (
          <Typography variant="overline">
            {t('gachaEndAt', { date: endAt })}
          </Typography>
        )}
        {deliveryDateText && (
          <Typography variant="overline">
            {t('gachaDeliveryDateText', { date: deliveryDateText })}
          </Typography>
        )}
      </Stack>
      <Stack direction="row" spacing={3}>
        <Button variant="outlined" size="small" onClick={onClickDetail}>
          {t('detail')}
        </Button>
        <Button
          variant="outlined"
          size="small"
          href={generatePath(routerPages.GachaItemList, {
            gachaId,
            artistId: artistId ?? '#',
          })}
        >
          {t('emissionList')}
        </Button>
      </Stack>
    </Stack>
  )
}
